import Button from "@components/buttons/Button"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import {
  body14Styles,
  paragraph18Styles,
  paragraph20Styles,
  paragraphStyles,
  subtextStyles,
} from "@constants/typography"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  @media ${breakpoints.laptop} {
    display: flex;
  }
`

const ContentWrapper = styled.div`
  flex-direction: column;
  display: flex;
  padding-top: 40px;

  @media ${breakpoints.tablet} {
    padding-top: 61px;
  }

  @media ${breakpoints.laptop} {
    width: 100%;
    padding-top: 54px;
  }
`

const Text = styled.div`
  margin-bottom: 31px;
  padding: 0 20px;

  h6 {
    ${body14Styles}
    margin: 0 0 34px;
  }

  p {
    ${paragraph20Styles}
    margin: 0 0 34px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  p.finePrint {
    ${subtextStyles}
    margin: 0 0 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul {
    margin: 0 0 34px;
    padding-left: 18px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  li {
    color: ${colors.mediumDarkGray};

    p {
      ${paragraphStyles}
      color: ${colors.mediumDarkGray};
    }
  }

  @media ${breakpoints.tablet} {
    padding: 0 calc(2.5 / 12 * 100vw) 0 calc(1 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 22px;
    padding: 0;

    h6 {
      margin-bottom: 41px;
    }

    p {
      margin-bottom: 41px;
      font-size: 22px;
      line-height: 33px;
    }

    p.finePrint {
      ${subtextStyles}
      margin-bottom: 12px;
    }

    ul {
      margin-bottom: 41px;
    }

    li {
      p {
        ${paragraph18Styles}
        color: ${colors.mediumDarkGray};
      }
    }
  }
`

const DownloadWrapper = styled.div`
  padding: 0 20px;

  @media ${breakpoints.laptop} {
    width: 320px;
    padding: 0;
  }
`

const Download = styled.a`
  width: 100%;

  @media ${breakpoints.laptop} {
    width: 320px;
  }
`

const ResourcesBlock = ({ media, text }) => {
  return (
    <Container>
      <ContentWrapper>
        <Text>{text}</Text>
        {media && (
          <DownloadWrapper>
            <Download download href={media?.file?.url || ""} target="_blank">
              <Button text="Download" />
            </Download>
          </DownloadWrapper>
        )}
      </ContentWrapper>
    </Container>
  )
}

export default ResourcesBlock
